<mat-dialog-content class="mt-2">
    <div class="check-bg">
        <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home"></mat-icon> -->
        <mat-icon class="btn-home material-icons-outlined"  matBadgeColor="primary"  matBadgeSize="small">check</mat-icon>
    </div>
    <div class="font-family-NB email-header complate">{{dialogData.message}}</div>
</mat-dialog-content>